<template>
    <!-- 火葬予約空き状況表 葬祭業者WEBからも利用 -->
    <div>
        <table :style="$props.disabled ? 'pointer-events: none;' : ''">
            <thead v-if="$props.headerVisible">
                <tr>
                    <th></th>
                    <th v-for="x in RowHeaders" :key="x">
                        {{ x.split("\n")[0] }}<br>{{ x.split("\n")[1] }}
                    </th>
                </tr>
                <template v-if="columnHeaderType==1 && !inUserPage">
                    <tr>
                        <th class="pre" style="font-size: 0.9rem">仮予約件数</th>
                        <th class="pre" v-for="(x,i) in SumHeaders[0]" :key="i">{{x}}</th>
                    </tr>
                    <tr>
                        <th class="approved" style="font-size: 0.9rem">本予約件数</th>
                        <th class="approved" v-for="(x,i) in SumHeaders[1]" :key="i">{{x}}</th>
                    </tr>
                    <tr>
                        <th style="background: #C0C0C0; font-size: 0.9rem">予約取消件数</th>
                        <th style="background: #C0C0C0;" v-for="(x,i) in SumHeaders[2]" :key="i">{{x}}</th>
                    </tr>
                </template>
            </thead>
            <tbody>
                <tr v-for="(row, r) in Cells" :key="r">
                    <th>{{ ColHeaders[r].split("\n")[0] }}<br>{{ ColHeaders[r].split("\n")[1] }}</th>

                    <td v-for="(cell, c) in row" :key="`${r}-${c}`">
                        <div style="min-height: 2.8rem; height: 100%; display: flex; flex-direction: column; gap: 2px;">
                            <template v-if="cell.slotId != 0">
                                <!-- 予約者表示 -->
                                <div v-for="bo in cell.bookings" :key="bo.bookingId"
                                    style="display: flex; flex-direction: column; justify-content: center; padding: 2px 5px; min-height: 30px"
                                    :class="getBookingClass(bo)" @click="$props.columnHeaderType==1 ? $emit('booking-click', bo) : ()=>{}"
                                    :clickable="$props.columnHeaderType==1">
                                    
                                    <div v-if="bo.bookingState==3">仮押さえ</div>
                                    <div v-else class="j-mincho">{{ bo.infoName1 }} {{ bo.infoName2 }}</div>
                                    <template v-if="!inUserPage">
                                        <div style="font-size: 0.9rem">{{ bo.companyNameShort }}</div>
                                    </template>
                                </div>

                                <!-- 予約可否 -->
                                <div v-if="cell.freeCount > 0 && $props.columnHeaderType==1" class="slot-state" @click="$emit('empty-click', cell)" clickable>○</div>
                                <div v-if="cell.freeCount > 0 && $props.columnHeaderType!=1" class="slot-state">{{ cell.isHoliday ? "△" : "○" }}</div>
                                <div v-if="cell.freeCount == 0 && cell.slotCount==0" class="slot-state">－</div>
                                <div v-if="cell.freeCount == 0 && cell.slotCount >0" class="slot-state">×</div>
                            </template>
                            <!-- レコード無し -->
                            <div v-if="cell.slotId==0" class="slot-state">－</div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div v-if="$props.footerVisible" style="display: flex; gap: 2px; align-items: center; font-size: 0.9rem; margin-left: auto;">
            <div style="margin: 0 2px; padding: 0 5px" class="reserved">仮押さえ</div>
            <div style="margin: 0 2px; padding: 0 5px" class="pre">仮予約</div>
            <div style="margin: 0 2px; padding: 0 5px" class="booked">本予約</div>
            <div style="margin: 0 2px; padding: 0 5px" class="approved">承認済</div>
            <div style="margin: 0 2px; padding: 0 5px" class="canceled">無効予約</div>
        </div>
    </div>
</template>

<script>
import Util from "../../assets/utility.js"
import "../../assets/api/requestTypes.js"

export default {
    props: {
        baseDate : {
            type: Date,
        },
        records : {
            default: [],
        },
        disabled : {
            type: Boolean,
            default: false,
        },
        columnCount:{
            type: Number,
        },
        headerVisible: {
            type: Boolean,
            default: true,
        },
        footerVisible: {
            type: Boolean,
            default: true,
        },
        columnHeaderType:{
            type: Number,
            default: 1,
            //1:火葬 2:お別れ室 3:霊安室
        },
        inUserPage:{
            type: Boolean,
            default: false,
            //
        }
    },
    data() {
        return {
            /** 枠無しの場合は { slotId : 0 } 
             * @type { BookingState[][] } */
            Cells: [],
            ColHeaders : [],
            RowHeaders : [],
            SumHeaders : [
                [], //仮予約
                [], //本予約
                [], //取消
            ],
        }
    },
    watch: {
        records:{
            deep: true,
            handler(){
                this.refresh()
            }
        }
    },
    mounted() {
        this.refresh()
    },
    methods: {
        refresh(){
            /** @type {BookingStatus[]} */
            let data = this.records

            //日時の正規化
            let days = []
            let now = this.baseDate //Util.getToday()
            for(let i=0; i<this.columnCount; i++){
                days.push(new Date(now.getTime() +  i * 1440 * 60 * 1000))
            }

            //時刻の正規化
            let times = Util.distinct(data.map(x=>x.bookingTime))
            times = times.sort((x,y)=>x-y)

            //ヘッダ
            this.RowHeaders = days.map(x=>Util.formatDate(x, "M/d\n(ddd)"))
            this.ColHeaders = times.map(x=>Util.formatTime(x))

            if(this.$props.columnHeaderType == 2){
                this.ColHeaders = this.ColHeaders.map(x=>`お別れ室\n(${x.split(":")[0]}時火葬)`)
            }else if(this.$props.columnHeaderType == 3){
                this.ColHeaders = this.ColHeaders.map(()=>`霊安室`)
            }

            //セルデータ
            let map = new Map(data.map(x=>[`${x.bookingDate}-${x.bookingTime}`, x]))

            this.Cells = []
            for(let i=0; i < times.length; i++){
                this.Cells[i] = new Array(days.length)
                for(let j=0; j < days.length; j++){
                    this.Cells[i][j] = map.get(`${days[j]}-${times[i]}`) ?? { slotId: 0 }
                }
            }
            
            //集計行
            this.SumHeaders[0] = [...days.map(()=>0)] //仮
            this.SumHeaders[1] = [...days.map(()=>0)] //本
            this.SumHeaders[2] = [...days.map(()=>0)] //消
            for(let i=0; i<days.length; i++){
                let dayRecs = data.filter(x=>x.bookingDate.getTime() == days[i].getTime())
                dayRecs.forEach(x=>{
                    this.SumHeaders[0][i] += x.bookings.filter(b=>b.bookingState==1).length
                    this.SumHeaders[1][i] += x.bookings.filter(b=>b.bookingState==2).length
                    this.SumHeaders[2][i] += x.bookings.filter(b=>b.bookingState==4).length
               })
            }

        },
        getBookingClass(booking){
            if(booking.bookingState == 4) return "canceled"
            if(booking.approved == 1) return "approved"
            if(booking.bookingState == 3) return "reserved"
            if(booking.bookingState == 2) return "booked"
            if(booking.bookingState == 1) return "pre"
            return ""
        },
    },
}
</script>

<style scoped>
table{
    width: 100%;
    height: 100%;
    table-layout: fixed;
}
th{
    background: lightgray;
    text-align: center;
    padding: 2px;
    font-weight: normal;
}
th:first-child{
    width: 90px;
}
tbody th{
    vertical-align: top;
}
td{
    height: 100%;
    text-align: center;
    background: #eceef1;
}

[clickable]:hover{
    cursor: pointer;
    outline: 1px solid #9f98bb;
}

.slot-state{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    font-size: 1.2rem;
    min-height: 40px;
}
.slot-state[clickable]{
    background: #565684;
    color: white;
}

.approved{
    background: #a5c9ff;
}
.booked{
    background: #b6e7a3;
}
.pre{
    background: #f8c5c5; 
}
.reserved{
    background: #F7E7CA;
}
.canceled{
    color: gray;
    background: #E0E0E0;
    text-decoration: line-through dimgray;
}
</style>